import styled from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const CardStepElement = styled.div``;

export const CardStepTitle = styled(Typography.TextH6_14_20)`
    margin-bottom: 8px;
`;

export const CardStepText = styled(Typography.TextBody_16_24)``;

export const CardStepChildren = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 24px;
`;
